import { render, staticRenderFns } from "./scrollablesecond.vue?vue&type=template&id=0190127f&scoped=true"
import script from "./scrollablesecond.vue?vue&type=script&lang=js"
export * from "./scrollablesecond.vue?vue&type=script&lang=js"
import style0 from "./scrollablesecond.vue?vue&type=style&index=0&id=0190127f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0190127f",
  null
  
)

export default component.exports